angular
  .module("signatoriesIdentificationDeclaration.components", [])
  .component("signatoriesIdentificationDeclaration", {
    templateUrl: "ng/components/signatoriesIdentificationDeclaration/signatoriesIdentificationDeclaration.html",
    bindings: {
      options: "=",
      // rif: "=",
      onOutputReturns: "&?",
      page: "=",
      userPickedDigitalSignature: "&?"
    },
    controllerAs: "signatoriesIdentificationDeclarationCtrl",
    controller: function (
      $rootScope,
      HttpService,
      $configService

    ) {
      var self = this;

      self.$configService = $configService;

      self.$onInit = function () {

        self.rif =  'PROVA';
       
        self.state = {
          userEnabled: false,
          userPickedDigitalSignature: !!self.userEnabledToDigitalSignature ? "true" : "false"
        };

        self.filter = {
          limit: window.innerHeight > 620 ? '6' : '4',
          pageIndex: 1,
          offset: 0,
          totalPages: 0,
          orderColumnName: "INSERT_DATE",
          orderType: "DESC"
        };

      };

     self.handleChange = function(){
         self.userPickedDigitalSignature({ value: self.state.userPickedDigitalSignature });
     }
   
     
    }

  })